module.exports = __webpack_public_path__ + "img/stork_balance.5cca8b8e.svg";